var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button-white',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],on:{"click":function($event){return _vm.create(_vm.day)}}},[_vm._v("Schreibtisch freigeben")]),_vm._v(" "),_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }